import React from 'react';
import { Header } from '../components/Layout/Header';
import { Footer } from '../components/Layout/Footer';

const RefundsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-base-200">
      <Header />

      {/* Content */}
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-base-100 rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>
          <p className="text-sm text-base-content/70 mb-8">Last updated: January 2025</p>

          <div className="prose prose-lg max-w-none">
            <div className="alert alert-warning mb-8">
              <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.962-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
              <span><strong>NO REFUNDS</strong> - All credit purchases are final</span>
            </div>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Our No-Refund Policy</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              At SuprHR, we maintain a strict no-refund policy for all credit purchases. This policy is designed to
              keep our service simple, efficient, and cost-effective for all users.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Why No Refunds?</h2>
            <ul className="list-disc list-inside space-y-3 text-base-content/80 mb-6 ml-4">
              <li><strong className="text-primary">Immediate Value Delivery:</strong> Credits are consumed immediately when processing resumes, providing instant AI analysis results</li>
              <li><strong className="text-primary">Transparent Pricing:</strong> Our credit packages are clearly priced with no hidden fees</li>
              <li><strong className="text-primary">Simple Service:</strong> No complex features or subscriptions - you pay only for what you use</li>
              <li><strong className="text-primary">Cost Efficiency:</strong> This policy helps us maintain competitive pricing for all users</li>
            </ul>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Before You Purchase</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              We encourage you to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-base-content/80 mb-6 ml-4">
              <li>Review our service capabilities and pricing</li>
              <li>Start with smaller credit packages to test the service</li>
              <li>Read our FAQ for common questions</li>
              <li>Contact us with any concerns before purchasing</li>
            </ul>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Credit Usage</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              Credits are used as follows:
            </p>
            <ul className="list-disc list-inside space-y-2 text-base-content/80 mb-6 ml-4">
              <li><strong>1 credit per resume screening</strong> - regardless of resume length or complexity</li>
              <li><strong>Credits never expire</strong> - use them whenever you need them</li>
              <li><strong>No partial refunds</strong> - even if you're dissatisfied with results</li>
              <li><strong>No refunds for unused credits</strong> - credits remain in your account until used</li>
            </ul>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Service Guarantee</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              While we don't offer refunds, we do guarantee:
            </p>
            <ul className="list-disc list-inside space-y-2 text-base-content/80 mb-6 ml-4">
              <li>Service availability and uptime</li>
              <li>Secure processing of your data</li>
              <li>Responsive customer support</li>
              <li>Continuous improvement of our AI models</li>
            </ul>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Exceptions</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              In rare cases, we may consider exceptions for:
            </p>
            <ul className="list-disc list-inside space-y-2 text-base-content/80 mb-6 ml-4">
              <li>Technical issues preventing service use</li>
              <li>Unauthorized charges or billing errors</li>
              <li>Service outages lasting more than 24 hours</li>
            </ul>
            <p className="text-base-content/80 leading-relaxed mb-6">
              Such cases are reviewed individually and are not guaranteed.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">Contact Us</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              If you have questions about this policy or need assistance with your account, please contact us:
            </p>
            <div className="bg-base-200 p-4 rounded-lg">
              <p className="font-semibold">Email:</p>
              <p>contact@kautilya.app</p>
              <p className="text-sm text-base-content/70 mt-2">We typically respond within 24 hours</p>
            </div>

            <div className="alert alert-info mt-8">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span>This refund policy is part of our Terms of Use. By using SuprHR, you agree to this policy.</span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RefundsPage; 